import { useMemo } from 'react';

import { Account } from 'dashboard/models/account';
import { Document } from 'dashboard/models/document';
import { GraphQuery } from 'dashboard/models/graph-query';
import { Inquiry } from 'dashboard/models/inquiry';
import { Report, SUPPORTED_REPORT_TYPES } from 'dashboard/models/report';
import { ReportRun, SUPPORTED_REPORT_RUN_TYPES } from 'dashboard/models/report-run';
import { SAR } from 'dashboard/models/sar';
import { Transaction } from 'dashboard/models/transaction';
import { ALL_VERIFICATION_API_MODEL_TYPES, Verification } from 'dashboard/models/verification';
import { ApiModel } from 'lib/interfaces/api';

export type PersonaObject =
  | Account
  | Document
  | GraphQuery
  | Inquiry
  | Report
  | ReportRun
  | SAR
  | Transaction
  | Verification;

export const useObjectMap = (caseObjects: PersonaObject[]) => {
  const fields: Record<string, PersonaObject[]> = useMemo(() => {
    const orderedReportTypes = [
      ApiModel.ReportBusinessAdverseMedia,
      ApiModel.ReportBusinessAssociatedPersons,
      ApiModel.ReportBusinessLookup,
      ApiModel.ReportBusinessWatchlist,
    ];
    // TODO: [melissa] this should be passed in from backend
    const fields = {
      business_documents: caseObjects.filter((obj) => obj.type === ApiModel.DocumentGeneric),
      business_reports: caseObjects
        .filter((obj) => orderedReportTypes.includes(obj.type))
        .sort((a, b) => orderedReportTypes.indexOf(a.type) - orderedReportTypes.indexOf(b.type)),
      accounts: caseObjects.filter((obj) => obj.type === ApiModel.Account),
      inquiries: caseObjects.filter((obj) => obj.type === ApiModel.Inquiry),
      reports: caseObjects.filter((obj) => SUPPORTED_REPORT_TYPES.includes(obj.type)),
      'report-runs': caseObjects.filter((obj) => SUPPORTED_REPORT_RUN_TYPES.includes(obj.type)),
      transactions: caseObjects.filter((obj) => obj.type === ApiModel.Transaction),
      verifications: caseObjects.filter((obj) =>
        ALL_VERIFICATION_API_MODEL_TYPES.includes(obj.type),
      ),
      sars: caseObjects.filter((obj) => obj.type === ApiModel.SAR),
    };
    return fields;
  }, [caseObjects]);

  return fields;
};
